import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { SMS_GATEWAYS } from "models";
import { ApiInstance } from "utils/Api";

type DeleteTwilioSubAccountPayload = {
  dealer_id: number;
};

export const useDeleteTwilioSubAccountMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeleteTwilioSubAccountPayload) => (await ApiInstance.post("/sub_accounts/delete", payload, ENV.twilioBaseURL)).data,
    onSuccess: payload => {
      const dealerUpdate = {
        twilio_account_sid: "",
        twilio_api_key: "",
        twilio_phone_number: "",
        is_twilio_sub_account_managed: false,
        twilio_monthly_dollar_limit: 0,
        twilio_monthly_dollar_limit_usage_trigger_sid: "",
        twilio_monthly_sms_limit: 0,
        twilio_monthly_sms_limit_usage_trigger_sid: "",
        twilio_daily_dollar_limit_usage_trigger_sid: "",
        has_twilio_api_secret: false,
        has_twilio_auth_token: false,
        sms_gateway_id: SMS_GATEWAYS.Disabled
      };

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...dealerUpdate })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({ ...selectedDealer, ...dealerUpdate });
    }
  });
